import { useFetch, formatQueryError, usePost } from '../utils/queries';

const SURVEY_BASE = 'survey';

export interface SurveyData {
  status: 'closed' | 'open' | 'in_progress' | 'completed' | 'report_ready';
  startDate: string;
  endDate: string;
  totalQuestions: number;
  totalAnswers: number;
  paymentDueDate: string;
  paid: boolean;
  sectionDetails: any[];
  sectoralReports: { Title: string }[];
}

function useGetUserSurvey({
  salesforceContactId,
  enabled = true
}: {
  salesforceContactId: string;
  enabled?: boolean;
}) {
  const context = useFetch(`${SURVEY_BASE}/${salesforceContactId}/`, undefined, { enabled });

  return {
    ...context,
    data: context.data as SurveyData,
    error: formatQueryError(context)
  };
}

function useGetSurveyPaymentDetails({
  salesforceContactId
}: {
  salesforceContactId: string;
}) {
  const context = useFetch(`${SURVEY_BASE}/${salesforceContactId}/payment/`);

  return {
    ...context,
    data: context.data,
    error: formatQueryError(context)
  };
}

function useUpdateSurveyPaymentMethod(salesforceContactId: string) {
  return usePost(`${SURVEY_BASE}/${salesforceContactId}/payment-method/`,
    {},
    {
      options: { invalidateAll: true }
    });
}

export {
  useGetUserSurvey,
  useGetSurveyPaymentDetails,
  useUpdateSurveyPaymentMethod
};
